(() => {
  "use strict";

  const backToTop = document.querySelector(".back-to-top");
  const revealItems = document.querySelectorAll(".reveal");
  const timedCampaigns = document.querySelectorAll(".campaign[data-start][data-end]");
  const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const packNav = document.querySelector("[data-pack-nav]");
  const packGate = document.querySelector("[data-pack-gate]");
  const packOpen = document.querySelector("[data-pack-open]");
  const packSkip = document.querySelector("[data-pack-skip]");
  const packReplay = document.querySelector("[data-pack-replay]");
  const packMessage = document.querySelector("[data-pack-message]");
  let packTimerId;

  document.querySelectorAll('a[href="#"][aria-disabled="true"]').forEach((link) => {
    link.addEventListener("click", (event) => event.preventDefault());
  });

  const updateCampaignStatus = () => {
    const now = new Date();

    timedCampaigns.forEach((campaign) => {
      const start = new Date(campaign.dataset.start);
      const end = new Date(campaign.dataset.end);
      const status = campaign.querySelector(".campaign__status");

      campaign.classList.remove("is-upcoming", "is-active", "is-ended");

      if (now < start) {
        campaign.classList.add("is-upcoming");
        if (status) status.textContent = "開催前";
      } else if (now > end) {
        campaign.classList.add("is-ended");
        if (status) status.textContent = "終了しました";
      } else {
        campaign.classList.add("is-active");
        if (status) status.textContent = "開催中";
      }
    });
  };

  const toggleBackToTop = () => {
    backToTop?.classList.toggle("is-visible", window.scrollY > 600);
  };

  backToTop?.addEventListener("click", () => {
    window.scrollTo({ top: 0, behavior: reducedMotion ? "auto" : "smooth" });
  });

  window.addEventListener("scroll", toggleBackToTop, { passive: true });

  const preparePack = () => {
    if (!packNav || !packGate || !packReplay || !packMessage) return;

    window.clearTimeout(packTimerId);
    packNav.classList.remove("is-pack-opening", "is-pack-opened");
    packNav.classList.add("is-pack-ready");
    packNav.removeAttribute("aria-busy");
    packGate.hidden = false;
    packReplay.hidden = true;
    packMessage.textContent = "";
    if (packOpen) packOpen.disabled = false;
  };

  const finishPack = (message = "ド級5大企画、解放！") => {
    if (!packNav || !packGate || !packReplay || !packMessage) return;

    window.clearTimeout(packTimerId);
    packNav.classList.remove("is-pack-ready", "is-pack-opening");
    packNav.classList.add("is-pack-opened");
    packNav.removeAttribute("aria-busy");
    packGate.hidden = true;
    packReplay.hidden = false;
    packMessage.textContent = message;
    if (packOpen) packOpen.disabled = false;
  };

  const openPack = () => {
    if (!packNav || !packGate || packNav.classList.contains("is-pack-opening")) return;

    window.clearTimeout(packTimerId);
    packNav.classList.remove("is-pack-ready", "is-pack-opened");
    packGate.hidden = false;

    // Replay時にもCSSアニメーションを先頭から確実に再生する。
    void packNav.offsetWidth;

    packNav.classList.add("is-pack-opening");
    packNav.setAttribute("aria-busy", "true");
    if (packOpen) packOpen.disabled = true;
    if (packMessage) packMessage.textContent = "5枚の企画カードを開封中…";

    packTimerId = window.setTimeout(() => finishPack(), 2050);
  };

  if (packNav && packGate && packOpen && packSkip && packReplay && packMessage && !reducedMotion) {
    preparePack();
    packOpen.addEventListener("click", openPack);
    packSkip.addEventListener("click", () => finishPack("ド級5大企画、解放！"));
    packReplay.addEventListener("click", () => {
      preparePack();
      packTimerId = window.setTimeout(openPack, 260);
    });
  }

  if (reducedMotion || !("IntersectionObserver" in window)) {
    revealItems.forEach((item) => item.classList.add("is-visible"));
  } else {
    const observer = new IntersectionObserver(
      (entries, currentObserver) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add("is-visible");
          currentObserver.unobserve(entry.target);
        });
      },
      { threshold: 0.12 }
    );

    revealItems.forEach((item) => observer.observe(item));
  }

  updateCampaignStatus();
  toggleBackToTop();
})();
